export default __webpack_public_path__ + "static/media/SWT1480.34I-36155_-21218_0.894cbeb3.jpg";